import React, { useEffect } from 'react';

import { Map } from 'immutable';
import { useTranslation } from 'react-i18next';
import { useMenu, useSearchBox } from 'react-instantsearch';

import { useDispatch, useSelector } from 'react-redux';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { entityGetByPath, referenceLoadingReset, Block } from '@uncinc/react-drupal-core';

import { SearchMaatjesProjects, Hero, Button } from '../../../components';
import { APP_OPTIONS, REQUEST_TYPE_MAATJE_WORDEN } from '../../../config/constants';

import {
  facetAttributes,
} from '../../../components/SearchMaatjesProjects/config';

import './style.scss';

const SearchResultsDisplay = (count: number) => {
  const { t } = useTranslation();
  const { query } = useSearchBox();
  const requestTypeFacet = facetAttributes.filter((facetAttribute) => facetAttribute.field === 'field_request_type')[0];
  // @ts-expect-error
  const { items } = useMenu(requestTypeFacet);
  const refinedRequestType = items.find((facetAttribute) => facetAttribute.isRefined);
  const activeRequestType = refinedRequestType?.value || REQUEST_TYPE_MAATJE_WORDEN;

  return (
    <>
      <p>
        {t(`maatjes_search.${activeRequestType}_intro`)}
      </p>
      <div className="Searchkit__Stats__result">
        {t('maatjes_search.search_result.label')}
        <span className="Searchkit__Stats__result__count"> {count} </span>
        {t('maatjes_search.search_result.projects_in')}
        <span className="Searchkit__Stats__result__region"> {query || t('maatjes_search.all_municipalities')}</span>
      </div>
    </>
  );
};

const SearchMaatjes = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const entityId = useSelector((state: any) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state: any) => state.getIn(['entity', 'entityType'], null));
  const entity = useSelector((state: any) => state.getIn([entityType, entityId], Map()));
  const image = entity.getIn(['field_media_item', 0]);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const ctaBlockID = APP_OPTIONS?.parameters.ctaBlockMaatjeSignup;

  // Currently we fetch the story overview landing page entity to get the hero image.
  // We will change this in : https://uncinc.monday.com/boards/420919839/pulses/9076742058.
  useEffect(() => {
    dispatch(referenceLoadingReset());
    dispatch(entityGetByPath(
      APP_OPTIONS?.parameters.overviewUrls.maatjes_find,
    ) as any);
  }, []);

  const handleMoreFiltersClick = () => {
    const facetsWrapper = document.querySelector('.SearchMaatjes__Facets__wrapper');
    if (facetsWrapper) {
      facetsWrapper.classList.add('showCheckboxes');
    }
  };
  return entity.size > 0 && (
    <div className="SearchMaatjes">
      <SearchMaatjesProjects>
        <Hero
          image={image.toJS()}
          className="Hero__hero"
        >
          <div>
            <Container>
              <div className="Hero__hero__content">
                <div className="Hero__hero__content__text">
                  <h1 className="Hero__hero__content__text__title">
                    {t('maatjes_search.title')}
                  </h1>
                </div>
                <div className="Hero__hero__search">
                  <p className="Hero__hero__search__label">
                    {t('maatjes.search.label')}
                  </p>
                  <div className="Hero__hero__search__content">
                    {/* Input query */}
                    <SearchMaatjesProjects.SearchBar />
                  </div>
                </div>
              </div>
            </Container>
          </div>
        </Hero>
        <div className="SearchMaatjes__wrapper">
          <Container>
            <div className="row">
              <div className="col-12 col-lg-4 SearchMaatjes__Facets__padder">
                <div className="SearchMaatjes__Facets__wrapper">
                  <SearchMaatjesProjects.SearchFacets />
                  <div className="SearchMaatjes__Facets__moreFilters">
                    <Button
                      textual
                      type="textual"
                      onClick={handleMoreFiltersClick}
                      className="SearchMaatjes__Facets__moreFilters__button"
                    >
                      {t('searchkit.facets.more_filters')}
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-8">
                {/* Result stats */}
                <SearchMaatjesProjects.SearchStats
                  translation={SearchResultsDisplay}
                />
                {/* Results */}
                <SearchMaatjesProjects.SearchResults />
                {/* Pagination */}
                <SearchMaatjesProjects.SearchPagination
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  previousLabel={<a><i className="icon icon-arrow-left" /><span>{t('previous')}</span></a>}
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  nextLabel={<a><span>{t('next')}</span><i className="icon icon-arrow-right" /></a>}
                />
              </div>
            </div>
            <Block
              id={ctaBlockID}
              newBlock
            />
          </Container>
        </div>
      </SearchMaatjesProjects>
    </div>
  );
};

export default SearchMaatjes;
